const ORDER_TRADE_IN_RESULTS_EMPTY_STATE = (() => {
  const orderTradeInResultsEmptyState = () => document
    .getElementById('order-trade-in-results__empty-results-template')
    .content
    .cloneNode(true);

  return {
    orderTradeInResultsEmptyState,
  };
})();
